import React from "react";
import PropTypes from "prop-types";
import CompanyPage from "./companies/company_page";
import MyCompanyPage from "./companies/my_company_page";

function CompanyComponent(props) {
  const { editable } = props;

  return editable === true ?
    <MyCompanyPage {...props} /> : <CompanyPage {...props} />;
}

CompanyComponent.propTypes = {
  editable: PropTypes.bool.isRequired
};

export default CompanyComponent;
